import { v4 as uuidv4 } from 'uuid';

export class HashUtils {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static simpleHashFromObj = (obj: Record<string, any>) => {
    const str = JSON.stringify(obj);
    let hash = 0;
    let i = 0;
    const len = str.length;
    while (i < len) {
      // eslint-disable-next-line no-bitwise
      hash = ((hash << 5) - hash + str.codePointAt(i++)) << 0;
    }
    return `${hash}`;
  };

  static generateShortId = (length: number): string => {
    // 1. Generate a standard UUIDv4
    const fullId = uuidv4();

    // 2. Remove hyphens and grab the first 5 characters
    const shortId = fullId.replace(/-/g, '').substring(0, length);

    return shortId;
  };
}
